var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.authorized && (!_vm.enabled || _vm.currentUser))?_vm._t("loggedIn"):(_vm.authorized)?_vm._t("loggedOut"):_vm._t("unauthorized")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }